import { render } from "./MobileServicePackagesList.vue?vue&type=template&id=82199c94&scoped=true"
import script from "./MobileServicePackagesList.vue?vue&type=script&lang=js"
export * from "./MobileServicePackagesList.vue?vue&type=script&lang=js"

import "./MobileServicePackagesList.vue?vue&type=style&index=0&id=82199c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82199c94"]])

export default __exports__